$.fn.ProductCard = function() {
  let self = this
  self.button = self.find('.single_add_to_cart_button')

  self.initialize_button = function() {
    self.find('form.cart').CartForm({
      select: false,
      main: self.find('.card-product__price'),
    })
  }

  return function() {
    self.initialize_button()
    return self
  }()
}

$.fn.ReorderedGrid = function() {
  let self = this

  self.dropdown = self.parent().find('.filters-dropdown')
  self.dropdown_select = self.dropdown.find('.filters-dropdown__selected')
  self.dropdown_items = self.dropdown.find('.filters-dropdown__item')
  self.grid_items = self.find('.grid__item')

  return function() {
    self.grid_items.each(function() {
      $(this).data('originalIndex', $(this).index())
    })
    self.dropdown_items.each(function() {
      $(this).on('click', function() {
        if (!$(this).hasClass('filters-dropdown__item--selected')) {
          $('.filters-dropdown__item--selected').removeClass('filters-dropdown__item--selected')
          $(this).addClass('filters-dropdown__item--selected')
          if ($(this).data('label')) {
            self.dropdown_select.text($(this).data('label'))
          } else {
            self.dropdown_select.text($(this).text())
          }
          let order = $(this).data('order')
          self.fadeOut('fast', function() {
            self.grid_items.detach()
            self.grid_items = $(self.grid_items.toArray().sort(function(a, b) {
              if (order == 'price-asc') {
                return parseFloat($(a).data('sort-price')) - parseFloat($(b).data('sort-price'))
              } else if (order == 'price-desc') {
                return parseFloat($(b).data('sort-price')) - parseFloat($(a).data('sort-price'))
              } else {
                return parseFloat($(a).data('originalIndex')) - parseFloat($(b).data('originalIndex'))
              }
            }));
            self.grid_items.removeClass('fade-in fade-in--active slide-in slide-in--active')
            self.append(self.grid_items)
            self.fadeIn('fast')
          })
        }
      })
    })
    return self
  }()
}
